import { createWebHistory, createRouter } from 'vue-router'
import HomeView from '../views/Home.vue'
import LoginView from '../views/Login.vue'
import RegisterView from '@/views/Register.vue'
import { useAuthStore } from '@/stores/auth'
import HomeAdmin from '@/views/admin/HomeAdmin.vue'
import ListCategoryAdmin from "@/views/admin/category/ListCategoryAdmin.vue"
import ListProductAdmin from "@/views/admin/product/ListProductAdmin.vue"
import Shop from "@/views/public/Shop.vue";
import ViewProduct from "@/views/public/ViewProduct.vue";
import EditProduct from "@/views/admin/product/EditProduct.vue";
import ViewNotFound from "@/views/404.vue"
import ViewCart from "@/views/public/Cart.vue"
import ViewProfil from "@/views/public/Profil.vue"
import ViewFavorite from "@/views/public/Favorite.vue"
import ViewReviews from "@/views/public/Reviews.vue"
import ViewCheckoutInfo from "@/views/public/ordering/CheckoutInfo.vue"
import DeliveryInformations from "@/components/ordering/panels/DeliveryInformations.vue";
import SummaryPanel from "@/components/ordering/summary/SummaryPanel.vue";
import ViewOrderSuccess from "@/views/public/ordering/OrderSuccess.vue"
import ListOrder from "@/views/public/ordering/ListOrder.vue";
import DetailOrder from "@/views/public/ordering/DetailOrder.vue";
import ResetPassword from "@/views/public/reset/ResetPassword.vue";
import OrderAdmin from "@/views/admin/orders/OrderAdmin.vue";
import OrderDetailAdmin from "@/views/admin/orders/OrderDetailAdmin.vue";
import Visite from "@/views/Visite.vue";
import Histoire from "@/views/Histoire.vue";

const routes = [
    {
        path: '/',
        name: 'app_home',
        component: HomeView,
        meta: {
            layout: 'default'
        }
    },
    {
        path: '/connexion',
        name: 'app_login',
        component: LoginView,
        meta: {
            layout: 'no-header-fouter',
            title: 'Connexion'
        }
    },
    {
        path: '/inscription',
        name: 'app_register',
        component: RegisterView,
        meta: {
            layout: 'no-header-fouter',
            title: 'Inscription'
        }
    },
    {
        path: '/admin',
        name: 'app_admin',
        component: HomeAdmin,
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration',
        }
    },
    {
        path: '/admin/orders',
        component: OrderAdmin,
        name: 'app_admin_order',
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration'
        }
    },
    {
        path: '/admin/category',
        component: ListCategoryAdmin,
        name: 'app_admin_category',
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration'
        }
    },
    {
        path: '/admin/product',
        component: ListProductAdmin,
        name: 'app_admin_product',
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration'
        }
    },
    {
        path: '/admin/product/:id',
        component: EditProduct,
        name: 'app_admin_edit_product',
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration'
        }
    },
    {
        path: '/admin/order/:id',
        name: 'app_order_admin_detail',
        component: OrderDetailAdmin,
        meta: {
            isAdmin: true,
            layout: 'admin',
            title: 'Administration'
        }
    },
    {
        path: '/boutique',
        component: Shop,
        name: 'app_shop',
        meta : {
            title: 'Boutique'
        }
    },
    {
        path: '/boutique/:tag',
        component: ViewProduct,
        name: 'app_view_product'
    },
    {
        path: '/panier',
        component: ViewCart,
        name: 'app_view_cart',
        meta: {
            title: 'Panier'
        }
    },
    {
        path: '/order',
        component: ViewCheckoutInfo,
        meta: {
            title: 'Commande',
            layout: 'header-order'
        },
        props: true,
        children: [
            {
                path: 'checkout',
                component: DeliveryInformations,
                name: 'order_checkout',
                props: true
            },
            {
                path: 'summary',
                component: SummaryPanel,
                name: 'order_summary',
                props: route => ({ deliveryAddress: route.query.deliveryAddress })
            }
        ]
    },
    {
        path: '/order-success/:id',
        component: ViewOrderSuccess,
        name: 'app_order_success',
        meta: {
            title: 'Commande validé',
            layout: 'header-order'
        }
    },
    {
        path: '/mon-compte',
        component: ViewProfil,
        name: 'app_profil',
        meta: {
            isConnectView: true,
            title: 'Mon profil'
        }
    },
    {
        path: '/mes-favoris',
        name: 'app_favorite',
        component: ViewFavorite,
        meta: {
            isConnectView: true,
            title: 'Mes favoris'
        }
    },
    {
        path: '/mes-avis',
        name: 'app_reviews',
        component: ViewReviews,
        meta: {
            isConnectView: true,
            title: 'Mes avis'
        }
    },
    {
        path: '/mes-commandes',
        name: 'app_orders',
        component: ListOrder,
        meta: {
            isConnectView: true,
            title: 'Mes commandes'
        }
    },
    {
        path: '/mes-commandes/:id',
        name: 'app_order_detail',
        component: DetailOrder,
        meta: {
            isConnectView: true,
            title: 'Détail commande'
        }
    },
    {
        path: '/reset-password/:token',
        name: 'app_reset_password',
        component: ResetPassword,
        meta: {
            title: 'Réinitialisation',
            layout: 'no-header-fouter'
        }
    },
    {
        path: '/visite',
        name: 'app_visite',
        component: Visite,
        meta: {
            title: 'Visite'
        }
    },
    {
        path: '/histoire',
        name: 'app_histoire',
        component: Histoire,
        meta: {
            title: 'Notre histoire'
        }
    },
    {
        path: "/:notFound",
        component: ViewNotFound,
        name: 'app_view_notfound',
        meta: {
            layout: 'no-header-footer',
            title: '404'
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    const { title } = to.meta
    const defaultTitle = '𐌃𐌄Ᏽ𐌋𐌉𐌍ᏵØ'

    document.title = title ? title + ' | ' + defaultTitle : defaultTitle
    if (to.path === '/connexion' || to.path === '/inscription') {
        if (authStore.isConnected) {
            next({name: 'app_profil'})
        }
    }

    if (to.meta.isAdmin) {
        if (!authStore.isAdmin) {
            next({ name: 'app_home' })
        }
    }
    if (to.meta.isConnectView) {
        if (!authStore.isConnected) {
            next({ name: 'app_login', query: { next: to.path } })
        }
    }
    next()
})

export default router